import { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom'
import React from "react";
import { BaseUrl } from "../helper/BaseUrl";

const Header = () => {
  const [allData, setAllData] = useState([]);

  const [isOpen, setIsOpen] = useState(false); // Mobile menu toggle
  const [activeMenu, setActiveMenu] = useState(null); // Track active submenu
  // track which dropdown is open: "solutions", "industries", "transport", or null
  // const [activeDropdown, setActiveDropdown] = useState(null);
  // track sub dropdown inside solutions
  // const [isSubDropdownOpen, setIsSubDropdownOpen] = useState(false);

  // toggle main dropdowns
  // const handleDropdownToggle = (menu) => {
  //   if (activeDropdown === menu) {
  //     // same menu clicked → close it
  //     setActiveDropdown(null);
  //   } else {
  //     // open new menu and reset sub dropdown
  //     setActiveDropdown(menu);
  //     setIsSubDropdownOpen(false);
  //   }
  // };



  // const handleSubDropdownToggle = (e) => {
  //   e.stopPropagation(); 
  //   setIsSubDropdownOpen((prev) => !prev);
  // };
  const handleMenuToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleCloseMenu = () => {
    setIsOpen(false);
    setActiveMenu(null);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
    // setActiveDropdown(null);   
    // setIsSubDropdownOpen(false); 
  };

  // new js 

  const [activeIndex, setActiveIndex] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const dropdownRef = useRef(null);
  const locationsRequestedRef = useRef(false);
  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const toggleDropdown = (key) => {
    setOpenDropdown(openDropdown === key ? null : key);
    if (key === "locations") {
      fetcher();
    }
  };



  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setActiveIndex(null); // remove class
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);




  // API Calling
  async function fetcher() {
    if (locationsRequestedRef.current) return;
    locationsRequestedRef.current = true;
    try {
      const response = await fetch(`${BaseUrl}/api/location-pages`, {
        method: 'GET',
      });

      const result = await response.json();
      if (result.location_pages === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.location_pages);
    } catch (error) {
      locationsRequestedRef.current = false;
      console.error('Fetch error:', error.message);
    }
  }

  // Default images
  const defaultImages = {
    business: "/assets/images/about-drowdown-image1.png",
    career: "/assets/images/blog-dropdown-image11.webp",
    insights: "/assets/images/career-blog-image1.webp",
  };

  // Business submenu
  const businessMenu = [
    {
      key: "about", items: [
        { name: "About", link: "/about-us", img: "/assets/images/about-drowdown-image1.png" },
        { name: "Ethics & Compliances", link: "/about-us-ethics", img: "/assets/images/ethics-dropdown-image1.webp" },
        { name: "Operation Excellence", link: "/operation-exellence", img: "/assets/images/ethics-dropdown-image3.webp" },
        { name: "Sustainability", link: "/csr", img: "/assets/images/health-drodown-image12.webp" },
        // { name: "Governance", link: "/our-team", img: "/assets/images/governance-new-image.png" },
        { name: "Our Team", link: "/our-team", img: "/assets/images/governance-new-image.png" },
        { name: "Career", link: "/career", img: "/assets/images/ethics-dropdown-image2.webp" },
        // { name: "CSR", link: "/csr", img: "/assets/images/health-drodown-image12.webp" },
      ]
    },

    {
      key: "Transport", items: [
        { name: "Land Freight", link: "/land-freight-forwarding-logistics", img: "/assets/images/transport-dropdown-image1.webp" },
        { name: "Air Freight", link: "/air-freight-cargo-services", img: "/assets/images/transport-dropdown-image2.webp" },
        { name: "Ocean Freight", link: "/global-ocean-freight", img: "/assets/images/transport-dropdown-image3.webp" },
        { name: " Global Projects & Logistics", link: "/global-project-logistics", img: "/assets/images/transport-dropdown-image4.webp" },
        { name: "Intermodal Logistics", link: "/smart-warehouses", img: "/assets/images/transport-dropdown-image5.webp" },
      ]
    },
    {
      key: "Services", items: [
        { name: "Pharma & Healthcare", link: "/industries-healthcare", img: "/assets/images/health-drodown-image1.webp" },
        { name: "White Goods", link: "/wide-cargo-logistics", img: "assets/images/wide-good-dropdon-img1.webp" },
        { name: "Premium Goods", link: "/white-goods-logistics", img: "assets/images/health-drodown-image2.webp" },
        { name: "Warehousing", link: "/warehousing", img: "/assets/images/starting-dropdown-image4.webp" },
        //  { name: "Global Projects & Logistics", link: "/global-project-logistics", img: "/assets/images/starting-dropdown-image7.webp" },
        { name: "Smart Warehouses", link: "/smart-warehouses", img: "/assets/images/starting-dropdown-image7.webp" },
        { name: "FulFillment", link: "/order-fulfillment-logistics-services", img: "/assets/images/starting-dropdown-image5.webp" },
        { name: "Omnichannel", link: "/omnichannel-ecommerce-logistics-solution", img: "/assets/images/starting-dropdown-image6.webp" },
        { name: "Circular Economy", link: "/circular-economy-logistics-solution", img: "/assets/images/starting-dropdown-image7.webp" },
      ]
    },



    {
      key: "industries", items: [

        { name: "FMCG", link: "/fmcg-logistics", img: "/assets/images/health-drodown-image11.webp" },
        { name: "Automotives", link: "/auto-industry-logistics", img: "/assets/images/health-drodown-image7.webp" },
        { name: "Food Beverages", link: "/food-beverages", img: "/assets/images/health-drodown-image6.webp" },
        { name: "Retail & Lifestyle", link: "/retail-lifestyle", img: "/assets/images/health-drodown-image5.webp" },
        { name: "Fashion & Apparels", link: "/fashion-and-lifestyle-logistics", img: "/assets/images/health-drodown-image10.webp" },
        { name: "Chemicals", link: "/chemical-logistics", img: "/assets/images/health-drodown-image9.webp" },
        { name: "Sports", link: "/sports-logistics", img: "/assets/images/health-drodown-image4.webp" },
        { name: "Technology", link: "/technology-logistics", img: "/assets/images/health-drodown-image8.webp" },
        { name: "Entertainment", link: "/entertainment-logistics", img: "/assets/images/health-drodown-image3.webp" },
        { name: "Cosmetics", link: "/cosmetics", img: "/assets/images/cosmetic-energy-image.webp" },
        { name: "Electronic", link: "/industries-electronics", img: "/assets/images/header-electronics-image.webp" },
        { name: "Energy", link: "/energy", img: "/assets/images/header-energy-image.webp" },
        { name: "Govt Sector", link: "/govtsector", img: "/assets/images/government-energy-image.webp" },
      ]
    },
    {
      key: "Solutions", items: [
        { name: "SWIM", link: "/swim", img: "/assets/images/swim-header-img.webp" },
        { name: "Drizzle", link: "/drizzle", img: "/assets/images/dox-header-img.webp" },
        { name: "Fins", link: "/fins", img: "/assets/images/fins-header-img.webp" },
        { name: "Aquarium", link: "/aquarium", img: "/assets/images/aquarium-header-img.webp" },
        { name: "Wision", link: "/wision", img: "/assets/images/wision-header-img.webp" },
        { name: "Doxinfinity", link: "/doxinfinity", img: "/assets/images/drizzle-header-img.webp" },
        // { name: "VAWLT", link: "/", img: "/assets/images/menu-items.png" },
        { name: "Vaclogix", link: "/vaclogix", img: "/assets/images/vaclogix-heade-img.webp" },
        // { name: "iPALLET", link: "/", img: "/assets/images/hub-dropdown-image1.webp" },
      ]
    },

    {
      key: "locations", items: allData?.map((loc, index) => ({
        name: loc?.page_city,
        link: "/" + loc?.location_page_slug,
        img: BaseUrl + loc?.header_menu_image,
      }))
    },

    {
      key: "Custom Services", items: [
        { name: "Our Solutions for Small  Businesses", link: "/shipping-and-receiving-support", img: "/assets/images/starting-dropdown-image1.webp" },
        { name: "Our Solutions for Medium Businesses", link: "/cost-effective-logistics-small-medium-businesses", img: "/assets/images/ethics-dropdown-image3.webp" },
        { name: "Our Solutions for Large Enterprises", link: "/large-enterprises-scalable-logistics-solutions", img: "/assets/images/starting-dropdown-image3.webp" },

      ]
    },



  ]

  // Career items
  const careerItems = [
    { name: "About", link: "/about-us", img: "/assets/images/blog-dropdown-image11.webp" },
    { name: "Career", link: "/career", img: "/assets/images/blog-dropdown-image12.webp" },
    { name: "Operation Exellence", link: "/operation-exellence", img: "/assets/images/blog-dropdown-image13.webp" },
    { name: "Sustainability", link: "/csr", img: "/assets/images/health-drodown-image12.webp" },
    { name: "Our Team", link: "/our-team", img: "/assets/images/governance-new-image.png" },
    { name: "Contact us", link: "/contact-us", img: "/assets/images/header-contact-us.webp" },
  ];

  // Insights items
  const insightsItems = [
    { name: "Blogs", link: "/blog-page", img: "/assets/images/career-blog-image1.webp" },
    // { name: "Case Studies", link: "/", img: "/assets/images/career-blog-image2.webp" },

    { name: "Press Release", link: "/press-release", img: "/assets/images/career-blog-image3.webp" },
    { name: "Gallery", link: "/gallery", img: "/assets/images/career-blog-image4.webp" },
    { name: "Frequently Ask", link: "/faq", img: "/assets/images/career-blog-image5.webp" },
    { name: "Privacy Policy", link: "/privacy-policy", img: "/assets/images/career-blog-image2.webp" },
  ];

  // Get current hover image
  const getHoverImage = () => {
    if (hoveredItem) return hoveredItem.img;
    if (activeIndex === 1) {
      if (openDropdown) {
        const menu = businessMenu.find(m => m.key === openDropdown);
        if (menu && menu.items.length > 0) return menu.items[0].img;
      }
      return defaultImages.business;
    }
    if (activeIndex === 2) return defaultImages.career;
    if (activeIndex === 3) return defaultImages.insights;
    return defaultImages.business;
  };

  // Get current heading
  const getHoverName = () => {
    if (hoveredItem) return hoveredItem.name;
    if (activeIndex === 1) {
      if (openDropdown) return openDropdown.charAt(0).toUpperCase() + openDropdown.slice(1);
      return "Business";
    }
    if (activeIndex === 2) return "Career";
    if (activeIndex === 3) return "Insights";
    return "Business";
  };

  //   const [openDropdown, setOpenDropdown] = useState(null);
  //   const [hoveredItem, setHoveredItem] = useState(null);
  //   const [activeIndex, setActiveIndex] = useState(null); // single state for all dropdowns

  //   const handleClick = (index) => {
  //     setActiveIndex(activeIndex === index ? null : index); // toggle: same click closes
  //   };


  //   const toggleDropdown = (dropdownName) => {
  //     setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  //   };






  //   // const defaultHoverImage = "/assets/images/business-img.png"; // Default image

  //   const defaultHoverImage1 = "/assets/images/team-img.png"; // Default image
  // const getHoverImage1 = () => {
  //     return hoveredItem ? hoveredItem.img : defaultHoverImage1;
  //   };

  //   const parentImages = {
  //     about: "/assets/images/contact-bg-image.png",
  //     industries: "/assets/images/about-image.png",
  //     solutions: "/assets/images/contact-bg-image.png",
  //   };

  //   const defaultImage = "/assets/images/contact-bg-image.png";

  //   const getHoverImage = () => {
  //     if (hoveredItem) return hoveredItem.img;
  //     if (openDropdown) return parentImages[openDropdown];
  //     return defaultImage;
  //   };

  //   const getHoverName = () => {
  //     if (hoveredItem) return hoveredItem.name;
  //     if (openDropdown === "about") return "About";
  //     if (openDropdown === "industries") return "Industries";
  //     if (openDropdown === "solutions") return "Solutions";
  //     return "Business";
  //   };

  return (
    <>
      <div className="main-header">
        <header className="header-area">
          <div className="container">
            <div className="row align-items-center header-reverse">
              <div className="col-5 col-lg-4 col-sm-2">
                <div className="logo">
                  <Link to="/">
                    <img src="/assets/images/heaer-logo.webp" alt="Logo" />
                  </Link>
                </div>
              </div>
              <div className="col-7 col-lg-8 col-sm-10 col-static" ref={dropdownRef}>
                <div className="menu-section ">
                  <div className="menu-inner">
                    <div className="menu-item">
                      <ul className="item">
                        {/* Business */}
                        <li className="child-item">
                          <Link className={`child-item ${activeIndex === 1 ? "active-dropdown-li" : ""}`} onClick={() => handleClick(1)} >Business    <i className="header-top fa-solid fa-chevron-down"></i>   </Link>
                          <div className={`menu-dropdwon-section ${activeIndex === 1 ? "active-dropdwon" : ""}`}>
                            <div className="container">
                              <div className="menu-row-navigtaion">
                                <div className="main-navigation__level-wrapper">
                                  <ul className="main-navigation__level scroll-bar">
                                    {businessMenu.map(menu => (
                                      <li className={openDropdown === menu.key ? "active-link" : ""} key={menu.key}>
                                        <div className="menu-contant" onClick={() => toggleDropdown(menu.key)}>
                                          <Link className="child-dropdown">{menu.key.charAt(0).toUpperCase() + menu.key.slice(1)} <i className="fa-solid fa-chevron-right"></i></Link>
                                          <div className={`dropdown-level-2 ${openDropdown === menu.key ? "active" : ""}`}>
                                            <ul className="main-navigation__level--2 scroll-bar">
                                              {menu.items.map(item => (
                                                <li onClick={() => handleClick()} key={item.name} onMouseEnter={() => setHoveredItem(item)} onMouseLeave={() => setHoveredItem(null)}>
                                                  <Link to={item.link}>{item.name}</Link>
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        </div>
                                      </li>
                                    ))}


                                  </ul>
                                </div>
                                <div className="hover-bg-image-wrpper">
                                  <div className="hover-bg-image-inner">
                                    {activeIndex === 1 && (
                                      <>
                                        <img src={getHoverImage()} alt={getHoverName()} loading="lazy" />
                                        <div className="name-wrapper" style={{ position: "absolute", bottom: "30px", left: "0px", color: "#fff" }}>
                                          <div className="name-text" style={{ fontWeight: "bold" }}>{getHoverName()}</div>
                                          {hoveredItem && <div className="arrow-wrapper"><Link to={hoveredItem.link} style={{ color: "#fff", textDecoration: "underline" }}><i className="fa-solid fa-arrow-right"></i></Link></div>}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        {/* Career */}
                        <li className="child-item">
                          <Link className={`child-item ${activeIndex === 2 ? "active-dropdown-li" : ""}`} onClick={() => handleClick(2)} > Company <i className="header-top fa-solid fa-chevron-down"></i>   </Link>
                          <div className={`menu-dropdwon-section ${activeIndex === 2 ? "active-dropdwon" : ""}`}>
                            <div className="container">
                              <div className="menu-row-navigtaion">
                                <div className="main-navigation__level-wrapper">
                                  <ul className="main-navigation__level scroll-bar">
                                    {careerItems?.map(item => (
                                      <li key={item.name} onMouseEnter={() => setHoveredItem(item)} onMouseLeave={() => setHoveredItem(null)}>
                                        <div className="menu-contant">
                                          <Link onClick={() => handleClick()} to={item.link}>{item.name}</Link>
                                        </div>

                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="hover-bg-image-wrpper">
                                  <div className="hover-bg-image-inner">
                                    {activeIndex === 2 && (
                                      <>
                                        <img src={getHoverImage()} alt={getHoverName()} loading="lazy" />
                                        <div className="name-wrapper" style={{ position: "absolute", bottom: "30px", left: "0px", color: "#fff" }}>
                                          <div className="name-text" style={{ fontWeight: "bold" }}>
                                            {hoveredItem ? hoveredItem.name : "Career"}
                                          </div>
                                          {hoveredItem && (
                                            <div className="arrow-wrapper">
                                              <Link to={hoveredItem.link} style={{ color: "#fff", textDecoration: "underline" }}>
                                                <i className="fa-solid fa-arrow-right"></i>
                                              </Link>
                                            </div>
                                          )}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>


                        {/* Insights */}
                        <li className="child-item">
                          <Link className={`child-item ${activeIndex === 3 ? "active-dropdown-li" : ""}`} onClick={() => handleClick(3)} >Insights   <i className="header-top fa-solid fa-chevron-down"></i> </Link>
                          <div className={`menu-dropdwon-section ${activeIndex === 3 ? "active-dropdwon" : ""}`}>
                            <div className="container">
                              <div className="menu-row-navigtaion">
                                <div className="main-navigation__level-wrapper">
                                  <ul className="main-navigation__level scroll-bar">
                                    {insightsItems.map(item => (
                                      <li key={item.name} onMouseEnter={() => setHoveredItem(item)} onMouseLeave={() => setHoveredItem(null)}>
                                        <div className="menu-contant">
                                          <Link onClick={() => handleClick()} to={item.link}>{item.name}</Link>
                                        </div>

                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="hover-bg-image-wrpper">
                                  <div className="hover-bg-image-inner">
                                    {activeIndex === 3 && (
                                      <>
                                        <img src={getHoverImage()} alt={getHoverName()} loading="lazy" />
                                        <div className="name-wrapper" style={{ position: "absolute", bottom: "30px", left: "0px", color: "#fff" }}>
                                          <div className="name-text" style={{ fontWeight: "bold" }}>
                                            {hoveredItem ? hoveredItem.name : "Insights"}
                                          </div>
                                          {hoveredItem && (
                                            <div className="arrow-wrapper">
                                              <Link to={hoveredItem.link} style={{ color: "#fff", textDecoration: "underline" }}>
                                                <i className="fa-solid fa-arrow-right"></i>
                                              </Link>
                                            </div>
                                          )}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>

                    <div className="demo-btn location-right">
                      <Link to="/location" className="theme-btn">
                        <span> Locations </span>
                      </Link>
                    </div>

                    <div className="demo-btn">
                      <a href="/tracking" className="theme-btn">
                        <span>Track Shipment</span>
                      </a>
                    </div>
                    <div
                      className={`hamburger-menu toogle-line toogle-menus ${isOpen ? "close-sign" : ""}`}
                      onClick={handleMenuToggle}
                    >
                      <label htmlFor="check" aria-label="check" className="menu-button wrapper-menu">
                        <input type="checkbox" aria-label="checkbox" id="check" />
                        <div className="line-menu half start"></div>
                        <div className="line-menu"></div>
                        <div className="line-menu half end"></div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
      <div className={`new-mobilemenu ${isOpen ? "active-menu" : ""}`}>
        <div className="container">
          <div className="mobile-area-wrapper">
            <ul className="item">
              <ul className="main-navigation__level ">
                {businessMenu.map(menu => (
                  <li className={openDropdown === menu.key ? "active-link" : ""} key={menu.key}>
                    <div className="menu-contant" onClick={() => toggleDropdown(menu.key)}>
                      <Link className="child-dropdown">{menu.key.charAt(0).toUpperCase() + menu.key.slice(1)} <i className="fa-solid fa-chevron-right"></i></Link>
                      <div className={`mobile-dropdown-level-2 ${openDropdown === menu.key ? "active" : ""}`}>
                        <ul className="main-navigation__level--2 scroll-bar ">
                          {menu.items.map(item => (
                            <li onClick={() => setIsOpen(!isOpen)} key={item.name} onMouseEnter={() => setHoveredItem(item)} onMouseLeave={() => setHoveredItem(null)}>
                              <Link to={item.link}>{item.name}</Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </li>
                ))}

                <li className="child-item">
                  <div className="menu-contant shipment-child">

                    <Link onClick={() => setIsOpen(!isOpen)} to="/tracking"> Track Shipment  <span className="shipment-new"><img src="/assets/images/new-icons.png" alt="New" className="img-responsive" /></span> </Link>
                  </div>
                </li>


                <li className="child-item">
                  <div className="menu-contant">
                    <Link onClick={() => setIsOpen(!isOpen)} to="/career"> Career </Link>
                  </div>
                </li>
                <li className="child-item">
                  <div className="menu-contant">
                    <Link onClick={() => setIsOpen(!isOpen)} to="/blog-page">Blogs </Link>
                  </div>
                </li>

                <li className="child-item">
                  <div className="menu-contant">
                    <Link onClick={() => setIsOpen(!isOpen)} to="/case-study">Case Studies </Link>
                  </div>
                </li>
                <li className="child-item">
                  <div className="menu-contant">
                    <Link onClick={() => setIsOpen(!isOpen)} to="/contact-us"> Contact Us </Link>
                  </div>
                </li>

                {/* <li className="child-item">
                  <div className="menu-contant">
                    <Link onClick={() => setIsOpen(!isOpen)} to="/faq"> Faq </Link>
                  </div>
                </li> */}
              </ul>
            </ul>
          </div>
        </div>
      </div>

    </>
  );
};
export default Header;
